import React, { useState } from 'react';
import {
  Typography,
  Button,
  TextField,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  FormControlLabel,
  Checkbox
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles((theme) => {
  return {
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
    dialogContent: {
      width: '100%',
      height: '100%',
    }
  };
});

export default function TermsAndConditions({ affiliate, onClose, onConfirm }) {
  const classes = useStyles();
  const [customerComment, setCustomerComment] = useState('');
  const [agreed, setAgreed] = useState(false);

  return (
    <Dialog
      open={affiliate}
      fullWidth
      maxWidth="lg"
      onClose={onClose}
      aria-labelledby="confirm-dialog"
    >
      <DialogTitle id="confirm-dialog">
        <Typography variant="h3">Apply to Program</Typography>
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <div className="p-10 border-1-muted border-radius-8">
          <div className="text-24 text-primary">{affiliate.name}</div>

          <div className="pl-20 pr-20 text-center">
            <div>
              <FormControlLabel
                className="font-bold"
                control={<Checkbox color="primary" checked={agreed} onChange={() => setAgreed((agreed) => !agreed)} />}
                label="I have read and agree to the Program Agreement for Affiliates"
                labelPlacement="end"
              />
            </div>
            <Button
              className="mb-10"
              color="primary"
              variant="contained"
              disabled={!agreed}
              onClick={() => onConfirm(customerComment)}
            >
              Join This Program
            </Button>
            <Typography className="text-dark-gray text-12 pb-2 text-left">
              Optional: Tell us about your promotional methods and general marketing plan for this merchant to help speed up approval. (Websites you’ll use, PPC terms, etc.)
            </Typography>
            <TextField
              multiline
              className="w-full mb-5"
              name="details"
              variant="outlined"
              onChange={(e) => setCustomerComment(e.target.value)}
            />
            <Typography className="text-dark-gray text-16 pb-2 text-left">
              Agreement
            </Typography>
            <div className="p-4 border-1-muted">
              <Typography className="text-dark-gray text-20 font-bold pb-3">
                {affiliate.name} Affiliate Terms and Conditions
              </Typography>
              <Typography className="text-dark-gray text-18 text-left whitespace-pre-wrap">
                {affiliate.termsAndConditions}
              </Typography>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
